import { render, staticRenderFns } from "./TaskTabs.vue?vue&type=template&id=020cb649"
import script from "./TaskTabs.vue?vue&type=script&lang=js"
export * from "./TaskTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports